import Button from "react-bootstrap/Button"
import Dropdown from "react-bootstrap/Dropdown"
import Modal from "react-bootstrap/Modal"
import { useEffect, useState } from "react"

import "./rebuild-cache.css"
import { API_ADDR } from "../../App"

interface Props {
  show: boolean
  runtimeEnv: string
  onHide?: (() => void) | undefined
}

export default function RebuildCache(props: Props) {

  const [progress, setProgress] = useState(0);  // 0=ready, 1=trigger me, 2=in progress, 3=done
  const [rebuildEnv, setRebuildEnv] = useState(props.runtimeEnv);  // The environment to rebuild
  const [messages, setMessages] = useState<string[]>(["Ready..."])

  useEffect(() => {
    if (props.show) {
      setProgress(0)
      setMessages(["Ready..."])
      setRebuildEnv(props.runtimeEnv)
    }
  }, [props.show, props.runtimeEnv])

  useEffect(() => {
    if (progress === 1) {
      // Trigger a rebuild of the selected environment
      setProgress(2)

      const responses = new EventSource(`${API_ADDR()}/api/rebuild?&environment=${rebuildEnv}`)
      responses.onmessage = (event) => {
        if (event.data === "DONE") {
          responses.close()
          setProgress(3)
        } else {
          //const newMessages = [...messages, event.data]
          setMessages(messages => [event.data, ...messages])
        }
      }
      responses.onerror = (errevent) => {
        console.log("Responses threw an error: ", errevent)
        responses.close()
      }
    }
  }, [progress, messages, rebuildEnv])

  return <Modal
    show={props.show}
    size="lg"
    centered
    backdrop="static"
    keyboard={false}
  >
    <Modal.Header>
      <Modal.Title>
        <div>Rebuild
          <Dropdown as="span" style={{ marginLeft: 5, marginRight: 5 }} onSelect={(eventkey) => setRebuildEnv(eventkey ?? "")}>
            <Dropdown.Toggle variant="secondary" id="choose-environment" disabled={progress > 0}>{rebuildEnv}</Dropdown.Toggle>
            <Dropdown.Menu>
              {props.runtimeEnv === "localhost"
                ? <Dropdown.Item key="localhost" eventKey="localhost">localhost</Dropdown.Item>
                : null
              }
              <Dropdown.Item key="dev" eventKey="dev">dev</Dropdown.Item>
              <Dropdown.Item key="staging" eventKey="staging">staging</Dropdown.Item>
              <Dropdown.Item key="live" className="extra-warn" eventKey="live">live</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          environment cache from scratch</div>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="messages-div">
        {messages.map((msg, idx) => <p key={idx}>{msg}</p>)}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" disabled={progress === 1} onClick={props.onHide}>{progress === 3 ? "Done" : "Cancel"}</Button>
      {progress < 3
        ? <Button variant="danger" onClick={() => setProgress(1)} disabled={progress >= 1}>Rebuild</Button>
        : null
      }
    </Modal.Footer>
  </Modal >
}